/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BinFileOrderByEnum } from '../models/bin-file-order-by-enum';
import { BinFileStatusEnum } from '../models/bin-file-status-enum';
import { OrderDirectionEnum } from '../models/order-direction-enum';
import { PagedDataDtoOfBinFileDto } from '../models/paged-data-dto-of-bin-file-dto';

@Injectable({
  providedIn: 'root',
})
export class BinFilesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation binFilesSearch
   */
  static readonly BinFilesSearchPath = '/v1/admin/bin-files';

  /**
   * Search BIN files.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `binFilesSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  binFilesSearch$Response(params?: {
    OrderBy?: Array<BinFileOrderByEnum>;
    Statuses?: Array<BinFileStatusEnum>;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<StrictHttpResponse<PagedDataDtoOfBinFileDto>> {

    const rb = new RequestBuilder(this.rootUrl, BinFilesService.BinFilesSearchPath, 'get');
    if (params) {
      rb.query('OrderBy', params.OrderBy, {"style":"form","explode":true});
      rb.query('Statuses', params.Statuses, {"style":"form","explode":true});
      rb.query('StartDate', params.StartDate, {});
      rb.query('EndDate', params.EndDate, {});
      rb.query('OrderDirection', params.OrderDirection, {});
      rb.query('Pager.PageSize', params['Pager.PageSize'], {});
      rb.query('Pager.PageIndex', params['Pager.PageIndex'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedDataDtoOfBinFileDto>;
      })
    );
  }

  /**
   * Search BIN files.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `binFilesSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  binFilesSearch(params?: {
    OrderBy?: Array<BinFileOrderByEnum>;
    Statuses?: Array<BinFileStatusEnum>;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<PagedDataDtoOfBinFileDto> {

    return this.binFilesSearch$Response(params).pipe(
      map((r: StrictHttpResponse<PagedDataDtoOfBinFileDto>) => r.body as PagedDataDtoOfBinFileDto)
    );
  }

  /**
   * Path part for operation binFilesReprocess
   */
  static readonly BinFilesReprocessPath = '/v1/admin/bin-files/{id}/reprocess';

  /**
   * Reprocess BIN file.
   *
   * Starts the reprocess for not processed BIN file
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `binFilesReprocess()` instead.
   *
   * This method doesn't expect any request body.
   */
  binFilesReprocess$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, BinFilesService.BinFilesReprocessPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Reprocess BIN file.
   *
   * Starts the reprocess for not processed BIN file
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `binFilesReprocess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  binFilesReprocess(params: {
    id: number;
  }): Observable<void> {

    return this.binFilesReprocess$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation binFilesDownload
   */
  static readonly BinFilesDownloadPath = '/v1/admin/bin-files/{id}/download';

  /**
   * Download BIN file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `binFilesDownload()` instead.
   *
   * This method doesn't expect any request body.
   */
  binFilesDownload$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, BinFilesService.BinFilesDownloadPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Download BIN file.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `binFilesDownload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  binFilesDownload(params: {
    id: number;
  }): Observable<Blob> {

    return this.binFilesDownload$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
